module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAtElEQVQ4T8WSsRHCMAxFpUI9o7ACE8AGMAJuopKktBszAmwAE7ACo9CrEOe7OOfkcGwud+BWfu+kLyEsfLiQh98LvPcrEfGqemfm21cd9PADANaq2jFzWy2YwFdmPoT8qgQ5eBBYa3eIuCUiY4x5pZuZg1NBi4gnAHgS0SZKSvBoBGvtBRH3URKKIhIDG2ae3s0og1TSfwxpZ+GPISYSKMHZLTjnzqHYNM2xdOpVa5yT/F/wBgQObxHCAWlJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/correct.png
// module id = 7qau
// module chunks = 1